export enum ClientStatus {
	New,
	Existent,
}
